export default (params) => {
    const tourCriteria = {};
    const element = params.toCountry;
    if (element) {
        tourCriteria.countries = [element];
    }

    return tourCriteria;
};